var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_266","data-name":"Group 266","transform":"translate(-330.968 -21.762)"},[React.createElement("rect",{"id":"Rectangle_3","data-name":"Rectangle 3","width":"27.419","height":"2.232","transform":"translate(330.968 41.15) rotate(-45)","fill":"#d5651b","key":0}),React.createElement("rect",{"id":"Rectangle_180","data-name":"Rectangle 180","width":"27.419","height":"2.232","transform":"translate(350.357 42.728) rotate(-135)","fill":"#d5651b","key":1})]));
}

Cross.defaultProps = {"width":"20.967","height":"20.967","viewBox":"0 0 20.967 20.967"};

module.exports = Cross;

Cross.default = Cross;
